function pickDirection(ctx) {
  const pos = ctx.movement.getPosition();
  const vp = ctx.environment.getViewport();
  const petCenter = pos.x + (ctx.config.size || 48) / 2;
  const platform = ctx.movement.getCurrentPlatform();

  if (petCenter < vp.width * 0.12) return 1;
  if (petCenter > vp.width * 0.88) return -1;

  if (platform && platform.right - platform.left < vp.width * 0.8) {
    const platCenter = (platform.left + platform.right) / 2;
    if (petCenter < platCenter - 30) return 1;
    if (petCenter > platCenter + 30) return -1;
  }

  return Math.random() < 0.5 ? -1 : 1;
}

export const walk = {
  id: 'walk',
  state: 'walk',
  system: false,

  enter(ctx) {
    ctx.walkDir = pickDirection(ctx);
    ctx.movement.walkTo(ctx.walkDir);
    ctx.stateTimer = ctx.getStateDuration('walk');
  },

  update(ctx, dt) {
    if (!ctx.movement.isGrounded()) {
      ctx.transition('fall');
      return;
    }
    if (ctx.movement.isAtEdge() || ctx.movement.isAtViewportEdge()) {
      ctx.transition('idle');
      return;
    }
    ctx.movement.walkTo(ctx.walkDir);
    ctx.stateTimer -= dt;
    if (ctx.stateTimer <= 0) ctx.transitionToNext();
  },

  exit(ctx) {
    ctx.movement.stopWalk();
  },
};
